<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Contracts</h4>
                                <h5 class="card-subtitle">Overview of your recent contracts</h5>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link
                                                :to="{name: 'newcontractstep1', params: {expressid: currentOrg.express_id}}"
                                                class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Contract
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <form>
                            <div class="form-row">
                                <div class="form-group col-md-3">
                                    <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :options="counterparties"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            @search-change="searchCounterparties"
                                            class="form-control"
                                            id="customer"
                                            label="Search Counterparty"
                                            name="customer"
                                            open-direction="bottom"
                                            placeholder="Customer"
                                            v-model="filter.partner">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Counterparty not found</span>
                                    </multiselect>
                                </div>
                                <div class="form-group col-md-2">
                                    <select class="custom-select form-control" id="inlineFormCustomSelect1" style="height: 42px;" v-model="filter.type">
                                        <option :value="null">Type</option>
                                        <option v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in types">
                                            {{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <select class="custom-select form-control" id="inlineFormCustomSelect" style="height: 42px;" v-model="filter.status">
                                        <option :value="null">Status</option>
                                        <option v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in statuses">
                                            {{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group col-md-1">
                                    <input class="form-control"
                                           name="purchase"
                                           placeholder="Id"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="filter.number">
                                </div>
                                <div class="form-group col-md-4">
                                    <div class="input-group" id="drp">
                                        <v-md-date-range-picker
                                                :auto-apply="false"
                                                :end-date="endDate"
                                                :opens="opens"
                                                :show-activator-bar="false"
                                                :show-activator-label="false"
                                                :show-custom-range-label="value"
                                                :start-date="startDate"
                                                @change="change"
                                                show-year-select>
                                        </v-md-date-range-picker>
                                        <div class="input-group-append">
                                            <button @click="getContracts(1)" class="btn btn-light btn-outline-success font-weight-bold" type="button">
                                                <i class="fa fa-search"/> Go!
                                            </button>
                                            <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold" type="button">
                                                <i class="fa fa-undo"/> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="table-responsive m-t-30" v-if="contracts.length>0">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="col-form-label p-l-10" for="records">Display</label>
                                    <div class="col-sm-1 p-t-5">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length" v-model="perPage">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>

                                    <div class="ml-auto">
                                        <span class="fa-xs fa-stack fa-1x ml-auto m-r-10 text-muted" v-if="exporting" title="Exporting, please wait ...">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                        <div class="btn-group">
                                            <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info dropdown-toggle" data-toggle="dropdown"
                                                    type="button">
                                                Operations
                                            </button>
                                            <div class="dropdown-menu">
                                                <a @click="exportContractAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                                    <i class="fa fa-file-excel"/> Export
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="table v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0">#</th>
                                    <th class="border-0">Status</th>
                                    <th class="border-0">Number</th>
                                    <th class="border-0">Type</th>
                                    <th class="border-0">Goods/Services</th>
                                    <th class="border-0">Created On</th>
                                    <th class="border-0">Counterparty</th>
                                    <th class="border-0">Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr @click="viewContract(c.id)" style="cursor: pointer;" v-bind:key="index"
                                    v-for="(c, index) in contracts">
                                    <td class="v-align-t">{{pageCount + index}}</td>
                                    <td class="v-align-t">
                                        <span class="label label-cyan" v-if="c.status === 'DRAFT'">Draft</span>
                                        <span class="label label-indigo" v-if="c.status === 'POSTED'">Posted</span>
                                        <span class="label label-dark-green"
                                              v-if="c.status === 'CONFIRMED'">Confirmed</span>
                                        <span class="label label-grey text-white" v-if="c.status === 'VOID'">Void</span>
                                    </td>
                                    <td class="v-align-t">{{c.contract_number}}</td>
                                    <td class="v-align-t">
                                        <div class="d-flex align-items-center">
                                            <div class="m-r-10">
                                                <span class="btn-md btn-outline-cyan" v-if="c.type === 'PURCHASE'">
                                                    <i class="fas fa-cart-arrow-down"></i>
                                                </span>
                                                <span class="btn-md btn-outline-primary" v-if="c.type === 'SALE'">
                                                    <i class="fas fa-credit-card"></i>
                                                </span>
                                            </div>
                                            <div class="">
                                                <h6 class="m-b-0 font-16">{{c.type | capitalize}}</h6>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="v-align-t">
                                        {{ getItemDescription(c.goods_services) }}
                                    </td>
                                    <td class="v-align-t">{{c.created_at | timeline}}</td>
                                    <td :title="c.counterparty.name" class="v-align-t">
                                        <div class="d-flex no-block align-items-center">
                                            <div class="m-r-10">
                                                <blockie :address="c.counterparty.email"></blockie>
                                            </div>
                                            <div class="">
                                                <h5 class="m-b-0 font-16 font-medium">{{c.counterparty.name}}</h5>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="v-align-t"><h5 class="m-b-0">{{c.total | money}}</h5></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="contracts.length>0">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import moment from "moment";
    import Multiselect from 'vue-multiselect';
    import XLSX from "xlsx";

    export default {
        name: "Contracts",
        components: {Blockie, Paginate, Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                total: 0,
                pageCount: 1,
                contracts: [],
                counterparties: [],
                filter: {
                    partner: null,
                    type: null,
                    status: null,
                    fromDate: null,
                    toDate: null,
                    number: null
                },
                types: ['SALE', 'PURCHASE'],
                statuses: ['DRAFT', 'POSTED', 'CONFIRMED', 'VOID'],
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                opens: 'right',
                value: true,
                perPage: 10,
                exporting: false
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getContracts(1);
            },
            async getContracts(page) {
                try {
                    let filter = {
                        partner: this.filter.partner ? this.filter.partner.partner_id : null,
                        type: this.filter.type,
                        status: this.filter.status,
                        fromDate: this.filter.fromDate,
                        toDate: this.filter.toDate,
                        number: this.filter.number
                    }
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/contracts`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            ...filter
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total     = reply.data.total;
                    this.contracts = reply.data.contracts;
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getContracts(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            viewContract(contractid) {
                this.$router.push({name: "viewcontract", params: {contractid: contractid}});
            },
            async searchCounterparties(searchText) {
                try {
                    let [buyers, sellers] = await Promise.all([
                        this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/sellers/search", {
                            params: {
                                search: searchText
                            }
                        }),
                        this.$http.get("/express/" + this.currentOrg.express_id + "/sales/buyer/search", {
                            params: {
                                search: searchText
                            }
                        })
                    ]);
                    this.counterparties   = [];

                    buyers.data.forEach(b => {
                        this.counterparties.push(b);
                    });
                    sellers.data.forEach(s => {
                        this.counterparties.push(s);
                    })
                } catch(e) {
                    console.log(e);
                }
            },
            async reset() {
                this.filter.partner  = null;
                this.filter.type     = null;
                this.filter.status   = null;
                this.filter.fromDate = null;
                this.filter.toDate   = null;
                this.filter.number   = null;
                await this.getContracts(1);
            },
            change(e) {
                this.filter.fromDate = e[0].toDate();
                this.filter.toDate   = e[1].toDate();
            },
            perPageRecordChange() {
                if(this.isFiltered) {
                    this.searchPo(1);
                } else {
                    this.getContracts(1);
                }
            },
            async exportContractAsExcel() {
                try {
                    this.exporting = true;
                    let filter     = {
                        partner: this.filter.partner ? this.filter.partner.partner_id : null,
                        type: this.filter.type,
                        status: this.filter.status,
                        fromDate: this.filter.fromDate,
                        toDate: this.filter.toDate,
                        number: this.filter.number
                    }
                    let reply      = await this.$http.get(`/express/${this.currentOrg.express_id}/contracts`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            ...filter
                        }
                    });
                    let data       = reply.data.contracts;
                    let contracts  = [];
                    data.forEach(d => {
                        contracts.push({
                            "Contract No": d.contract_number,
                            "type": d.type,
                            "Status": d.status,
                            "Created At": moment(d.created_at, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm"),
                            "Expires At": moment(d.expires_at, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm"),
                            "Owner Name": d.owner.name,
                            "Owner Email": d.owner.email,
                            "Counterparty Name": d.counterparty.name,
                            "Counterparty Email": d.counterparty.email,
                            "Provenance": d.provenance,
                            "Goods": this.getGoods(d.goods_services),
                            "Total": d.total.currency_symbol + " " + Number(d.total.amount).toFixed(2)
                        })
                    });

                    let workbook  = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(contracts);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Contracts');
                    XLSX.writeFile(workbook, 'contracts.xlsx');
                } catch(e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            },
            getGoods(goods) {
                let str = '';
                goods.forEach(g => {
                    str = str + `${g.name}(${g.rate.currency_symbol} ${g.rate.amount}/${g.quantity.unitSymbol}) - ${g.quantity.amount} ${g.quantity.unitSymbol} \n`;
                });
                return str;
            },
            getItemDescription(items) {
                let desc = '';
                let len  = items.length;
                items.forEach((item, index, arr) => {
                    if(index < 3) {
                        desc = desc + item.name + ' - ' + item.variety +  ', '
                    }
                });
                desc = desc.slice(0, -2);

                if(len > 3) {
                    len = len - 3;
                    if(len === 1) {
                        desc = desc + ' and ' + len + ' other good';
                    } else {
                        desc = desc + ' and ' + len + ' other goods';
                    }
                }
                return desc;
            }
        }
    }
</script>

<style scoped>
    .masked {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
